import * as _ from 'underscore';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'userName'
})
export class UserNamePipe implements PipeTransform {
  transform(user): string {
    if (!user) {
      return '';
    }

    let name: string;
    const hasFirst = !_.isEmpty(user.firstName);
    const hasLast = !_.isEmpty(user.lastName);

    if (hasFirst && hasLast) {
      name = [user.lastName.trim(), user.firstName.trim()].join(', ');
    } else if (hasFirst) {
      name = user.firstName.trim();
    } else if (hasLast) {
      name = user.lastName.trim();
    }
    return !!name ? name : user;
  }
}
